"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAG_OBJECT_ULTRA = void 0;
var client_1 = require("@apollo/client");
exports.FLAG_OBJECT_ULTRA = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation FlagObject($input: ID!) {\n    flagImage(imageId: $input) {\n      imageId\n    }\n  }\n"], ["\n  mutation FlagObject($input: ID!) {\n    flagImage(imageId: $input) {\n      imageId\n    }\n  }\n"])));
var templateObject_1;
